import { useState } from 'react';
import { postClientApplication, signClientApplicationUpload } from '../../../api/Rover/clientApplication';
import cclfLogo from '../../../images/logos/cclf-logo.png';
import { MultiStepApplicationProvider } from '../../../store/Context/MultiStepApplicationsProvider';
import type { ClientApplicationInterface } from '../../../types/ClientApplication';
import ApplicationForm from '../ApplicationForm';
import { cclfApplicationSteps } from '../ApplicationForm/templates/cclf';
import SubmitSuccess from '../SubmitSuccess';
import { validationSchema } from './validationSchema';

interface SubmitPayload {
  formData: ClientApplicationInterface;
  files: any[];
}
const defaultValues: ClientApplicationInterface = {
  orgInfo: {
    businessName: '',
    businessAddress: '',
    businessCity: '',
    state: '',
    zipCode: '',
    businessPhone: '',
    website: '',
    establishedDate: '',
    fein: '',
    leadContact: '',
    phone: '',
    email: '',
    cclfFinancing: false,
    socialDesignation: '',
    legalStatus: '',
    sponsors: [
      {
        name: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        phone: '',
        email: '',
        socialSecurity: '',
        ownershipPercent: 0,
        establishedDate: '',
        fein: '',
        website: '',
      },
    ],
  },
  orgExperience: {
    priorProjects: [
      {
        address: '',
        city: '',
        state: '',
        zipCode: '',
        projectType: '',
        constructionType: '',
        completionDate: '',
        status: '',
        projectCost: 0,
      },
    ],
    keyPrincipals: [
      {
        name: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        ownershipPercent: 0,
        yearsExperience: 0,
      },
    ],
  },
  financialRequest: {
    loanRequest: {
      loanRequestAmount: 0,
      maxUnits: 0,
    },
    projectInfo: {
      address: '',
      city: '',
      state: '',
      zipCode: '',
      sources: {
        borrowerEquity: 0,
        debt: 0,
      },
      uses: {
        averageAcquisition: 0,
        averageRehabilitation: 0,
        tenPContingency: 0,
        softCost: 0,
        closingCost: 0,
      },
    },
  },
  disclosuresReferences: {
    disclosure: {
      authorizedSigners: [
        {
          authorizedSigner: '',
        },
      ],
      hasLawsuits: false,
      hasLawsuitsExplain: '',
      defaultedOnLoan: false,
      defaultLoanExplain: '',
    },
    characterReference: [{ name: '', relationship: '', phone: '', email: '' }],
  },
};

const CCLFFormBase = () => {
  const [completed, setCompleted] = useState<boolean>(false);
  const onSubmit = async (payload: SubmitPayload) => {
    const { formData, files } = payload;
    const { orgInfo, financialRequest } = formData;

    let organizationAddress = `${orgInfo.businessAddress}, `;
    organizationAddress += `${orgInfo.businessCity}, `;
    organizationAddress += `${orgInfo.state}, `;
    organizationAddress += `${orgInfo.zipCode}, `;
    let sponsorAddr = 'None';
    if (!orgInfo.sponsors[0].isCorporate) {
      sponsorAddr = `${orgInfo.sponsors[0].address}, `;
      sponsorAddr += `${orgInfo.sponsors[0].city}, `;
      sponsorAddr += `${orgInfo.sponsors[0].state}, `;
      sponsorAddr += `${orgInfo.sponsors[0].zipCode}, `;
    }

    const clientApplication = {
      orgName: orgInfo.businessName,
      orgAddress: organizationAddress,
      sponsor: orgInfo.sponsors[0].name ? orgInfo.sponsors[0].name : 'Corporate',
      sponsorAddress: sponsorAddr,
      amountRequested: financialRequest.loanRequest.loanRequestAmount,
      socialDesignation: orgInfo.socialDesignation,
      ...formData,
      files,
      email: orgInfo.email,
      contactName: orgInfo.leadContact,
      program: 'Chicago Rebuild',
      responseDays: '14',
    };

    return postClientApplication({ data: clientApplication });
  };
  if (completed) {
    return <SubmitSuccess message='Thank you for your interest in Chicago Rebuild Program.' />;
  }
  return (
    <ApplicationForm
      title='Chicago Neighborhood Rebuild Program (CNRP)'
      logo={cclfLogo}
      validationSchema={validationSchema}
      signAsset={signClientApplicationUpload}
      steps={cclfApplicationSteps}
      onSubmit={onSubmit}
      onSuccess={() => {
        setCompleted(true);
      }}
    />
  );
};

export const CCLFForm = () => (
  <MultiStepApplicationProvider initialValues={defaultValues}>
    <CCLFFormBase />
  </MultiStepApplicationProvider>
);
